function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import isNumber from 'lodash/isNumber';
import toNumber from 'lodash/toNumber';
import get from 'lodash/get';
import withStyles from 'isomorphic-style-loader/withStyles';
import cn from 'classnames';
import App from 'modules/App';
import FormGroup from 'components/Form/FormGroup';
import Input from 'components/Form/Input';
import CollapsibleSection from 'components/CollapsibleSection';
import messages from '../../../../../messages';
import styles from '../GlucoseRanges.pcss';
var _React_PureComponent;
class GlucoseLevel extends (_React_PureComponent = React.PureComponent) {
    onSetValue(input) {
        const { value } = input;
        let { id } = input;
        id = id.replace('-toDisplay', '');
        const roundedValue = isNumber(value) ? toNumber(value.toFixed(1)) : value;
        this.props.onSetValue({
            id,
            value
        });
        this.props.onSetValue({
            id: `${id}-toDisplay`,
            value: roundedValue
        });
    }
    shouldSetDefaultValueAsPlaceholder(type, threshold) {
        if (type === 'default') return false;
        return get(this.props.formValues, this.getRelatedDefaultValueId(threshold), false);
    }
    getRelatedDefaultValueId(threshold) {
        return `values.default.${threshold}`;
    }
    getValue(id) {
        return get(this.props.formValues, `values.${id}-toDisplay`, null);
    }
    renderThreshold(threshold, label) {
        const { type, formValues } = this.props;
        const unitContentCss = this.props.unitSymbol === 'mg/dL' ? 'mgdl' : 'mmolL';
        const placeholder = this.shouldSetDefaultValueAsPlaceholder(type, threshold) ? get(formValues, this.getRelatedDefaultValueId(threshold)).toLocaleString() : App.messages.placeholders.typeValue;
        return /*#__PURE__*/ _jsx("div", {
            className: "row align-items-center",
            children: /*#__PURE__*/ _jsx("div", {
                className: "col",
                children: /*#__PURE__*/ _jsx(FormGroup, {
                    id: `${type}.${threshold}`,
                    labelMessage: label,
                    formValues: this.props.formValues,
                    children: /*#__PURE__*/ _jsx(Input, {
                        placeholder: placeholder,
                        onChange: (input)=>this.onSetValue(input),
                        type: "number",
                        classNameWrapper: cn(styles.glucoseLevel__unitSymbol, {
                            [styles[`glucoseLevel__unitSymbol--${unitContentCss}`]]: unitContentCss
                        })
                    })
                })
            })
        });
    }
    render() {
        const { type } = this.props;
        const { labels } = messages;
        return /*#__PURE__*/ _jsxs(CollapsibleSection, {
            headerMessage: messages.headers.glucoseType[type],
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "row mb-6",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-4",
                            children: this.renderThreshold('preMeal.lowThreshold-toDisplay', labels.glucosePreMealLow)
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-4",
                            children: this.renderThreshold('preMeal.highThreshold-toDisplay', labels.glucosePreMealHigh)
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "row mb-6",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-4",
                            children: this.renderThreshold('postMeal.lowThreshold-toDisplay', labels.glucosePostMealLow)
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-4",
                            children: this.renderThreshold('postMeal.highThreshold-toDisplay', labels.glucosePostMealHigh)
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "row mb-6",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-4",
                            children: this.renderThreshold('critical.lowThreshold-toDisplay', labels.glucoseCriticalLow)
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-4",
                            children: this.renderThreshold('critical.highThreshold-toDisplay', labels.glucoseCriticalHigh)
                        })
                    ]
                })
            ]
        });
    }
}
_define_property(GlucoseLevel, "propTypes", {
    // Explicit props
    formValues: PropTypes.object,
    type: PropTypes.string,
    unitSymbol: PropTypes.string,
    // Explicit actions
    onSetValue: PropTypes.func
});
export default withStyles(styles)(GlucoseLevel);
